import SearchBarFacets from "./SearchBarFacets";

export default SearchBarFacets;
